package com.exura.features.userprofile.domain.usecase

import com.exura.features.userprofile.domain.model.ProviderProfile
import com.exura.features.userprofile.domain.repository.ProviderProfileRepository

class SaveProviderProfileUseCase(
    private val profileRepository: ProviderProfileRepository,
) {
    suspend operator fun invoke(profile: ProviderProfile) : Result<ProviderProfile?> = profileRepository.saveSettings("profile", profile)
}
